import documentoService from "../services/documento";

export async function abrirDocumentoArquivo(documentoId) {
  if (!documentoId) {
    throw new Error("Documento inválido.");
  }

  const { blob, fileName } = await documentoService.obterArquivo(documentoId);
  const url = URL.createObjectURL(blob);
  const novaAba = window.open(url, "_blank", "noopener,noreferrer");

  if (!novaAba) {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "documento";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function documentoEstaEnviado(status) {
  return status !== 1;
}
